module.exports = __webpack_public_path__ + "static/asmet-color_black@2x-8383f8898b2a801ea2c5e9c42b14bf36.png";